import React, { useCallback } from 'react';

import useSWR from 'swr';

import byteSize from 'byte-size';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

import { fetchModelStorageSize } from '../../../../utils/api_functions/removeModel';

export const useModelStorageSize = (modelId, workspaceId) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR(['admin-model-storage-size', modelId, workspaceId], fetchModelStorageSize, {
    refreshInterval: 3000,
    loadingTimeout: 1000,
  });

  return {
    data,
    error,
    isLoading,
  }
}

export const ModelRemovalModal = ({
  error = null,
  model = {},
  onModelRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const modelId = model?.original?.name;
  const workspaceId = model?.original?.workspace?.workspace_id;
  const workspaceName = model?.original?.workspace?.name;

  const { data } = useModelStorageSize(modelId, workspaceId);
  const storage = data?.bytes || 0;
  const storageData = byteSize(storage);
  const storageLabel = `${storageData.value} ${storageData.unit}`;
  const isLastEntry = storage > 0;

  const onConfirm = useCallback(() => {
    onModelRemoved(modelId, workspaceId);
  }, [modelId, workspaceId, onModelRemoved])

  const message = isLastEntry
    ? 'The selected model, all its versions, and all its stored artifacts will be permanently deleted from Wallaroo. Are you sure?\n'
    : `The selected model and all its versions will no longer be available in the ${workspaceName} workspace. Are you sure?`

  return (
    <ConfirmationDialog
      title="Delete Model"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-model-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1 flex flex-col">
        <Label>
          { message }
        </Label>
        {
          isLastEntry && (
            <Label className="mt-2">
              Storage to be freed: { storageLabel }
            </Label>
          )
        }
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the model. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default ModelRemovalModal;
